import Footer from "./Footer";
import Header from "./Header";

function AppShell({ page, onNavigate, children }) {
  return (
    <div className="min-h-screen surface text-cyan-50">
      <Header page={page} onNavigate={onNavigate} />
      <main>{children}</main>
      <Footer onNavigate={onNavigate} />
    </div>
  );
}

export default AppShell;
